<script lang="ts">
  import PublicPricing from "./PublicPricing.svelte";
  import PublicReportCard from "./PublicReportCard.svelte";
  import GetStarted from "./GetStarted.svelte";
  import type { Plan } from "$lib/pricing";
  import FunnelReportCard from "@/components/customer/samples/FunnelReportCard.svelte";
  import GradeSizes from "@/components/customer/samples/GradeSizes.svelte";

  interface Props {
    pageType: string;
    uuid?: string;
    stripeKey?: string;
    plans?: Plan[];
  }

  let { pageType = "terms", uuid = "", stripeKey = "", plans = [] }: Props = $props();

  const isPrivacy = $derived(pageType === "privacy");
  const title = $derived(isPrivacy ? "Privacy Policy" : "Terms of Service");
</script>

{#if pageType === "pricing"}
  <PublicPricing />
{:else if pageType === "get_started"}
  <GetStarted {stripeKey} {plans} />
{:else if pageType === "report_card"}
  <PublicReportCard {uuid} />
{:else if pageType === "sample_funnel"}
  <FunnelReportCard />
{:else if pageType === "sample_grades"}
  <GradeSizes />
{:else}
<div class="min-h-screen flex items-start justify-center bg-background text-foreground px-4 py-10 text-base sm:px-6 lg:px-8">
  <div class="w-full max-w-lg space-y-8">
    <div class="flex flex-col items-center gap-2">
      <img src="/DT-logo.jpg" alt="DataTurk.ai" class="size-12 rounded-lg object-contain" />
      <span class="font-semibold text-xl tracking-wide" style="font-family: 'Sora', sans-serif;">DataTurk.ai</span>
    </div>

    <div class="space-y-6 rounded-xl border border-border bg-card p-6 shadow-sm sm:p-8">
      <h1 class="text-2xl font-semibold">{title}</h1>

      {#if isPrivacy}
        <p class="leading-relaxed">
          Please read this PDF file containing our
          <a
            href="/DataTurk_Privacy_Policy.pdf"
            rel="noopener noreferrer"
            target="_blank"
            class="font-medium text-primary underline underline-offset-4"
          >Privacy Policy</a>, which governs how we deal with your data and your role in helping do so.
        </p>
        <p class="leading-relaxed">
          Since you're here you might also be interested in our
          <a
            href="/DataTurk_Terms_of_Service.pdf"
            rel="noopener noreferrer"
            target="_blank"
            class="font-medium text-primary underline underline-offset-4"
          >Terms of Service</a>, which governs our mutual agreement.
        </p>
      {:else}
        <p class="leading-relaxed">
          Please read this PDF file containing our
          <a
            href="/DataTurk_Terms_of_Service.pdf"
            rel="noopener noreferrer"
            target="_blank"
            class="font-medium text-primary underline underline-offset-4"
          >Terms of Service</a>, which governs our mutual agreement.
        </p>
        <p class="leading-relaxed">
          Since you're here you might also be interested in our
          <a
            href="/DataTurk_Privacy_Policy.pdf"
            rel="noopener noreferrer"
            target="_blank"
            class="font-medium text-primary underline underline-offset-4"
          >Privacy Policy</a>, which governs how we deal with your data and your role in helping do so.
        </p>
      {/if}
    </div>
  </div>
</div>
{/if}
